import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmDeleteUserDialogWithOptions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			deleteOption: "selected",
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ConfirmDeleteUserDialogWithOptions', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

	handleDeleteOption(option) {
		this.setState({
			deleteOption: option
		})
	}

    render() {
		const { userDetails } = this.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: 122}}>
                    <h2 className="title">Confirm Delete</h2>
                    <p>Delete <b>{userDetails.firstName + ", " + userDetails.lastName}</b> from:</p>
					<table className="formTableTypeA">
						<tbody>
							<tr>
								<td>
									<input type="radio" onClick={this.handleDeleteOption.bind(this, "selected")} name="deleteFrom" id="deleteSelectedAccount" defaultChecked />
								</td>
								<td>
									<label htmlFor="deleteSelectedAccount">Account : <b data-name="userName">{this.props.state.user.selectedAccount.ACCOUNTNUMBER} - {this.props.state.user.selectedAccount.ACCOUNTDESCRIPTION}</b></label>
								</td>
							</tr>
							<tr>
								<td>
									<input type="radio" onClick={this.handleDeleteOption.bind(this, "all")} name="deleteFrom" id="deleteAll" />
								</td>
								<td>
									<label htmlFor="deleteAll">All CustomerNet Accounts</label>
								</td>
							</tr>
						</tbody>
					</table>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    <a className="blueButton yesButton" onClick={this.props.deleteUser.bind(this, this.state.deleteOption)}>Delete</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

ConfirmDeleteUserDialogWithOptions = connect(mapStateToProps)(ConfirmDeleteUserDialogWithOptions);
export default ConfirmDeleteUserDialogWithOptions;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmDeleteUserDialogWithOptions.js